import React from "react";
import { SubStepItem } from "./SubStepItem";
import { SubStepList } from "./styled";
export const SubSteps = ({ step, currentStep, handleNavigate, branding, }) => {
    return (React.createElement(SubStepList, null, step.subSteps.map((subStep) => {
        return (React.createElement(SubStepItem, { key: subStep.id, subStep: subStep, active: currentStep.id === subStep.id, handleNavigate: handleNavigate, branding: branding }));
    })));
};
//# sourceMappingURL=index.js.map